export default "/images/vendor/flag-icons/flags/4x3/ai.svg?0b7208a9ec34846dd15de643f91ceae9";